export default class Project {
  index:Number
  id:Number
  name:String
  organisation:String
  date:Date
  _element:HTMLElement;

  get element () {
    return this._element;
  }

  set element (element:HTMLElement) {
    this._element = element;

    var el:HTMLElement = (this.element.querySelector(".job-number")! as HTMLElement);
    this.id = Number(el.innerText);

    el = (this.element.querySelector(".job-name")! as HTMLElement);
    this.name = el.innerText;

    // el = (this.element.querySelector(".project-organisation-name")! as HTMLElement)
    // this.organisation = el.innerText;
    // this.date = new Date(this.element.dataset.date!);
  }
}
